import { ICalendarRepository } from "../../domain/calendars/ICalendarRepository";
import { ICalendar } from "../../domain/calendars/ICalendar";
import { localDb } from "./LocalDb";

export class CalendarRepository implements ICalendarRepository {
    get(): Promise<ICalendar[]> {
        return localDb.calendars.toArray();
    }
    getById(id: string): Promise<ICalendar | undefined> {
        return localDb.calendars.where("id").equals(id).first();
    }
    async save(calendars: ICalendar[]): Promise<void> {
        await localDb.calendars.bulkPut(calendars);
    }
    async delete(id: string): Promise<void> {
        await localDb.calendars.delete(id);
    }
}
